export namespace DocumentModels {
    export interface AmazonS3DocumentBase {
        id?: string;
        s3_object_id?: string;
    }
    export interface DocumentDetail extends AmazonS3DocumentBase {
        contact_linked: string;
        accounts_linked: AccountsLinked[];
        file_size_bytes: number;
        file_extension: string;
        document_type_lookup: string;
        crm_object_type_lookup: string;
        description: null;
        verified: number;
        verified_date: string;
        users_linked: UsersLinked[];
    }

    export interface AccountsLinked {
        id: string;
        enabled: boolean;
        entity_type: string;
        trading_account_limit: null;
        crm_id: string;
    }

    export interface UsersLinked {
        id: string;
        email: string;
    }

    export interface LegalDocument extends AmazonS3DocumentBase {
        crm_object_type_lookup: string;
        document_type_lookup: DocumentLegalType;
        description: string;
        created_date?: Date;
        file_extension?: string;
        file_size_bytes?: number;
    }

    export enum DocumentLegalType {
        ClientAgreement = 'CAP',
        DirectCrypto = 'DCP', // EIG only
        FinancialServicesGuide = 'FSG',
        LtgGoldrockIbAgreement = 'LTG',
        ReferralAgreement = 'RA',
        PrivacyPolicy = 'PPA',
        ProductDisclosureStatement = 'PDS',
        ReferAFriendChina = 'RAFC', // CN only
        Rewards = 'REWARDS', //CN  only
        ReferAFriend = 'RAF',
        RiskDisclosureNotice = 'RDP',
        USDTHandbook = 'UHB', // CN only

        // asic
        TargetMarketCommodities = 'TMDCO',
        TargetMarketCrypto = 'TMDCR',
        TargetMarketFX = 'TMDFX',
        TargetMarketIndicies = 'TMDIN',
        TargetMarketStocks = 'TMDST',
        FriendsFamilyReferralPromotion = 'FFRP',

        // fca
        KeyInformationDocumentCommodities = 'KIDCO',
        KeyInformationDocumentCurrency = 'KIDCU',
        KeyInformationDocumentIndices = 'KIDIN',
        KeyInformationDocumentShares = 'KIDSH',
        OrderExecutionPolicy = 'OEP',
        TermsAndConditions = 'TAC',

        // cysec
        AMLApproach = 'AMLAP',
        ClientCategorisationPolicy = 'CICAP',
        ComplaintsPolicy = 'COMPO',
        ConflictsOfInterestPolicy = 'CONIP',
        CookiesPolicy = 'COOKP',
        InvestorCompensationFundsPolicy = 'INCFP',
        KeyInformationDocumentCryptocurrencies = 'KIDCC',
        MarginLeveragePolicy = 'MALEP',
        SafeguardingOfClientsFundsAssetsPolicy = 'SAFAP'
    }
}
